/**
 * SPEC-007 §18/plan §7/T031/T032 — retry backoff and non-retryable
 * classification, isolated so both can be unit tested without timers or a
 * real coordinator.
 */
export const RETRY_DELAYS_MS = [1000, 2000, 5000] as const;

/** SAVE-REQ-016: these never auto-retry — they need a decision, not a resend. */
export const NON_RETRYABLE_CODES = new Set([
  'FUNNEL_SAVE_UNAUTHORIZED',
  'AUTH_UNAUTHORIZED',
  'AUTH_SESSION_EXPIRED',
  'FORBIDDEN',
  'FUNNEL_SAVE_NOT_FOUND',
  'NOT_FOUND',
  'FUNNEL_REVISION_CONFLICT',
  'FUNNEL_SAVE_TOO_LARGE',
  'FUNNEL_SAVE_VALIDATION_ERROR',
  'VALIDATION_ERROR',
]);

export function isRetryableErrorCode(code: string | undefined): boolean {
  if (!code) return true; // network failure / no structured code: transient by default
  return !NON_RETRYABLE_CODES.has(code);
}

export function isConflictErrorCode(code: string | undefined): boolean {
  return code === 'FUNNEL_REVISION_CONFLICT';
}

export function retryDelayForAttempt(attempt: number): number | null {
  return RETRY_DELAYS_MS[attempt] ?? null;
}
